import { CheckFileIngestion } from '@/api/geovera/specialty-check/check-file-ingestion';
import { Button } from '@/components/ui/button';
import {
	Tooltip,
	TooltipContent,
	TooltipProvider,
	TooltipTrigger,
} from '@/components/ui/tooltip';
import { ColumnDef } from '@tanstack/react-table';
import { format } from 'date-fns';
import { ArrowUpDown, Eye } from 'lucide-react';
import { Link } from 'react-router';

import { DownloadChecks } from './download-checks';

export const columns: ColumnDef<CheckFileIngestion>[] = [
	{
		accessorKey: 'id',
		header: ({ column }) => (
			<Button
				variant="ghost"
				onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
			>
				File Id
				<ArrowUpDown />
			</Button>
		),
		cell: ({ row }) => <div className="font-medium">{row.original.id}</div>,
	},
	{
		accessorKey: 'fileName',
		header: ({ column }) => (
			<Button
				variant="ghost"
				onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
			>
				File Name
				<ArrowUpDown />
			</Button>
		),
		cell: ({ row }) => <div className="font-medium">{row.original.fileName}</div>,
	},
	{
		accessorKey: 'importDate',
		header: ({ column }) => (
			<Button
				variant="ghost"
				onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
			>
				Import Date
				<ArrowUpDown />
			</Button>
		),
		cell: ({ row }) => {
			return (
				<div className="font-medium">
					{row.original.importDate ? format(row.original.importDate, 'P') : '---'}
				</div>
			);
		},
	},
	{
		accessorKey: 'totalChecks',
		header: () => <div className="text-right">Total Checks</div>,
		cell: ({ row }) => (
			<div className="text-right font-medium">{row.original.totalChecks}</div>
		),
	},
	{
		accessorKey: 'totalAmount',
		header: () => <div className="text-right">Total Amount</div>,
		cell: ({ row }) => {
			let formattedAmount;
			if (row.original.totalAmount) {
				formattedAmount = new Intl.NumberFormat('en-US', {
					style: 'currency',
					currency: 'USD',
				}).format(row.original.totalAmount);
			}
			return <div className="text-right font-medium">{formattedAmount}</div>;
		},
	},
	{
		id: 'actions',
		cell: ({ row }) => (
			<div>
				<TooltipProvider>
					<Tooltip>
						<TooltipTrigger asChild>
							<Link to={`/geovera/checks/${row.original.id}`}>
								<Button className="m-auto" variant="ghost">
									<Eye size={16} />
								</Button>
							</Link>
						</TooltipTrigger>
						<TooltipContent>
							<p>View Checks</p>
						</TooltipContent>
					</Tooltip>
				</TooltipProvider>

				<DownloadChecks fileIngestionId={row.original.id} />
			</div>
		),
	},
];
